export const pxToRem = (value: number) => {
    return `${value / 16}rem`;
  };